import {autoserializeAs, inheritSerialization} from 'cerialize';
import {ModelBase} from './model-base';

@inheritSerialization(ModelBase)
export class DressCode extends ModelBase {
  public static readonly type = 'DressCode';
  public readonly type = DressCode.type;

  @autoserializeAs('id')
  public id: number;

  @autoserializeAs('event_id')
  public eventId: string;

  @autoserializeAs('text')
  public text: string;
}
